import { HttpLoaderFactory } from '../../../application/translation/httpLoaderFactory';
var ɵ0 = HttpLoaderFactory;
var MonitorsModule = /** @class */ (function () {
    function MonitorsModule() {
    }
    return MonitorsModule;
}());
export { MonitorsModule };
export { ɵ0 };
